import { styled } from '@mui/material/styles';
import { accordionClasses, AccordionProps } from '@mui/material/Accordion';
import { accordionSummaryClasses } from '@mui/material/AccordionSummary';
import {
  MuiAccordion,
  MuiAccordionSummary,
  MuiAccordionDetails,
} from '../../../../../modules/material';

export const StyledAccordion = styled(MuiAccordion)<AccordionProps>((props) => {
  const { theme } = props;

  return {
    boxShadow: 'none',
    backgroundColor: 'transparent',
    color: theme.palette.neutral[700],

    '&:first-of-type': {
      borderRadius: 0,
    },
    '&:last-of-type': {
      borderRadius: 0,
    },
    [`&.${accordionClasses.expanded}`]: {
      margin: 0,
    },
    [`&.${accordionClasses.expanded}:before`]: {
      opacity: 1,
    },
  };
});
export const StyledAccordionSummary = styled(MuiAccordionSummary)((props) => {
  const { theme } = props;

  return {
    padding: 0,
    color: theme.palette.neutral[700],
    minHeight: 'var(--payment-component-accordion-title-min-height)',
    lineHeight: '29px',

    [`& .${accordionSummaryClasses.content}.${accordionSummaryClasses.expanded}`]:
      {
        margin: 'var(--payment-component-accordion-content-indention) 0 0',
      },

    [`& .${accordionSummaryClasses.expandIconWrapper}`]: {
      marginRight: '-2px',
    },
  };
});

export const StyledAccordionDetails = styled(MuiAccordionDetails)((props) => {
  const { theme } = props;

  return {
    padding:
      'var(--payment-component-accordion-content-small-indention) 0 var(--payment-component-accordion-content-indention)',
    borderBottom: `3px solid ${theme.palette.brandAccent.mainCustom}`,
  };
});
